
import '../styles/App.css';
import { useLocation, useNavigate } from "react-router-dom";
import Map from '../components/Map';
import { DATABASE_URL } from "../config/globals";
import { useEffect, useState } from 'react';

type User = {
  displayName: string;
  email?: string;
  [key: string]: any;
};

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState<User | null>(null);
  const newPinId = location.state?.newPinId;
  const imgUrl = location.state?.imgUrl;
  const date = location.state?.date

  
  useEffect(() => {
    if (!newPinId) {
      window.location.href = "/";
    } else {
      console.log(newPinId)
    }
  }, [newPinId, navigate]);

  useEffect(() => {
    fetch(DATABASE_URL+"/auth/user", { credentials: "include" })
      .then((res) => res.json())
      .then(async (data) => {
        if (data) {
          setUser(data);
        } else {
          setUser(null);
          await new Promise(resolve => setTimeout(resolve, 2000));
          window.location.href = "/";
        }
      })
      .catch(() => setUser(null));
  }, []);


  async function HandleUploadPin (newPinPosition: [number, number]) {
    console.log("SAVE THE POSITION: ",newPinPosition)
    try {
      const res = await fetch(DATABASE_URL+`/api/pins/${newPinId}`, {
          method: "PUT",
          credentials: "include",
          headers: {
          "Content-Type": "application/json",
          },
          body: JSON.stringify({ lat: newPinPosition[0], lng: newPinPosition[1] }),
        })
        
      const data = await res.json();
      console.log("✅ Pin saved:", data)

    } catch(err) {
      console.error("Error saving pin:", err)
    }
    navigate("/", { state: {  lat: newPinPosition[0], lng: newPinPosition[1] } });
  }

  console.log(imgUrl)

  return (
    <div>
      <h1 className="text-5xl p-5 text-gray-200 text-center">Click on the map below to mark a fish caught!</h1>
      <Map 
        onAction={HandleUploadPin}
        actionLabel="Pin Fish" 
        pinEnabled={true}
        userName = {user?.displayName} 
        imgUrl = {imgUrl}
        date = {date} />
    </div>
  );
}

export default App;
